import { Injectable } from '@angular/core';
import { Subject, Observable, Subscription } from 'rxjs';
import { ResponseObject } from '../model/ResponseObject';
import { HttpClient,HttpRequest,HttpResponse,HttpEvent} from '@angular/common/http';
import {GlobalDataServices} from '../core/services/globalDataServices'
import {ApplnConstants} from '../core/constants/ApplnConstants';
import { AssistanceSearchInput } from '../model/EligibilityModels/AssistanceSearchInput';
import { AssistanceSearchConfirmModel } from '../model/AssistanceSearchConfirmModel';
import {AppRouteConstants} from '../core/constants/AppRouteConstants';


@Injectable({
  providedIn: 'root'
})
export class AsstntsrchServiceService {

  asstSearchInput: AssistanceSearchInput;
  extAssisterId : string;
  extAsstRelnCd : string;

  constructor(public http: HttpClient, private _ahctHttp: GlobalDataServices) { }


  getFieldDropdowns()  : Observable<Response> {        
    
    return this._ahctHttp.getData(AppRouteConstants.hostURL+"anon/ASTSC/ASExecuteOnLoad");
  }

  getSrchRslts(assistanceSearchInput:AssistanceSearchInput): Observable<Response> {    
    return this._ahctHttp.postData(AppRouteConstants.hostURL+"anon/ASTSC/ASExecuteOnSearch/",assistanceSearchInput);
 }

 getPhoneTypeDropDown() : Observable<Response>
 {
  return this._ahctHttp.getData(AppRouteConstants.hostURL+"int/ASTSCAC/ASConfirmExecuteOnLoad");
 }
 getAsstSearchInput(assistanceSearchInput:AssistanceSearchInput)
 {
  return this.asstSearchInput;
 }

 setAsstSearchInput (assistanceSearchInput:AssistanceSearchInput)
 {
  this.asstSearchInput=assistanceSearchInput;
 }

 saveAssistAccountInfo(formInput:AssistanceSearchConfirmModel): Observable<Response> {    
  return this._ahctHttp.postData(AppRouteConstants.hostURL+"int/ASTSCAC/ASUpdateContactInfo/",formInput);
}

getAssistConfirmInfo(assistId:string)  : Observable<Response> {        
    
  return this._ahctHttp.getData(AppRouteConstants.hostURL+"int/ASTSCAC/ASConfirmInfo?assisterId="+assistId);
}

setApplnObjInSession(assistanceSearchInput : AssistanceSearchInput) : void {
  localStorage.setItem(ApplnConstants.ASST_SEARCH_OBJECT, JSON.stringify(assistanceSearchInput));
 }

 getApplnJsonNAsObj() :AssistanceSearchInput {
  return <AssistanceSearchInput>JSON.parse(localStorage.getItem(ApplnConstants.ASST_SEARCH_OBJECT));
 }

 setASTConfirmObjInSession(assistanceSearchConfirmModel : AssistanceSearchConfirmModel) : void {
  localStorage.setItem(ApplnConstants.ASTC_CNFRM_OBJECT, JSON.stringify(assistanceSearchConfirmModel));
 }

 getASTConfirmJsonNAsObj() :AssistanceSearchConfirmModel {
  return <AssistanceSearchConfirmModel>JSON.parse(localStorage.getItem(ApplnConstants.ASTC_CNFRM_OBJECT));
 }
setAssisterNameInSession(name: string) : void
{
  localStorage.setItem(ApplnConstants.ASSISTER_NAME,name);
}
getAssisterNameInSession():string
{
return localStorage.getItem(ApplnConstants.ASSISTER_NAME);
}

getUserAccountInfo(loginAppId: string)  : Observable<Response> {
  const postData = Number(loginAppId)      
  return this._ahctHttp.postData1("astConfirmExecuteOnLoad",postData);
}

setExtAsstisterId(extistingAssisterID: string){
  this.extAssisterId = extistingAssisterID;
}

getExtAssisterId():string{
  return this.extAssisterId;
}

setExtAsstRelnCd(extistingAssisterRelnCd: string){
  this.extAsstRelnCd = extistingAssisterRelnCd;
}

getExtAsstRelnCd():string{
  return this.extAsstRelnCd;
}
}
